import { useMemo } from 'react'
import moment from 'moment'
import type { ActivityType, UserData } from '../../types'
import { buildTimeline } from '../../utils/entries'
import { diffHuman } from '../../utils/calc'
import EntryCard from '../entries/EntryCard'
import IntakeCard from '../intake/IntakeCard'
import DaySummary from '../home/DaySummary'

interface HistoryProps {
  data: UserData
  onEdit: (type: ActivityType, index: number) => void
  onCopy: (type: ActivityType, index: number) => void
  onDelete: (type: ActivityType, index: number) => void
  onEditIntake: (id: number) => void
  onCopyIntake: (id: number) => void
  onDeleteIntake: (id: number) => void
}

export default function History({
  data,
  onEdit,
  onCopy,
  onDelete,
  onEditIntake,
  onCopyIntake,
  onDeleteIntake,
}: HistoryProps) {
  const grouped = useMemo(() => buildTimeline(data), [data])
  const dates = Object.keys(grouped)

  if (dates.length === 0) {
    return (
      <div className="card text-center text-[var(--text-secondary)] mt-4">
        Nothing logged yet. Use the buttons above to add your first entry.
      </div>
    )
  }

  return (
    <div className="space-y-6 mt-4">
      <DaySummary data={data} />
      {dates.map((date) => (
        <section key={date}>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-[var(--text-secondary)] mb-2">
            {diffHuman(moment(date, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss'), false)}
          </h2>
          <div className="space-y-3">
            {grouped[date].map((item) =>
              item.kind === 'move' ? (
                <EntryCard
                  key={`m-${item.entry.type}-${item.entry.id}-${item.datetime}`}
                  entry={item.entry}
                  onEdit={onEdit}
                  onCopy={onCopy}
                  onDelete={onDelete}
                />
              ) : (
                <IntakeCard
                  key={`i-${item.id}-${item.datetime}`}
                  intake={item.intake}
                  id={item.id}
                  onEdit={onEditIntake}
                  onCopy={onCopyIntake}
                  onDelete={onDeleteIntake}
                />
              ),
            )}
          </div>
        </section>
      ))}
    </div>
  )
}
